import { render, staticRenderFns } from "./VendorPage.vue?vue&type=template&id=6cf63218&scoped=true&"
import script from "./VendorPage.vue?vue&type=script&lang=js&"
export * from "./VendorPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf63218",
  null
  
)

export default component.exports